module.exports = __webpack_public_path__ + "img/product_116.5f23986.webp";